import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import AppContext from "../Context/Context";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import {
  addMinutes,
  FilterJsonExactlyMatching,
  formateDate,
  GetIndexExactlyMatchingColumn,
  IsDateTimeBetweenTwoDates,
  VanAvailabilityTypes,
} from "../Shared/Utility";

function VanAvailability() {
  const [isAnimation, setIsAnimation] = useState(false);
  const [vanTypes, setVanTypes] = useState<any[]>([]);
  const [vans, setVans] = useState<any>([]);
  const [vansData, setVansData] = useState<any>([]);
  const [selectedAvailabilityTypeID, setSelectedAvailabilityTypeID] =
    useState<number>(1);
  const [curentlySelectedDate, setCurentlySelectedDate] = useState<string>(
    new Date().toISOString().substr(0, 10)
  );
  const [currentlyClickedSlot, setCurrentlyClickedSlot] = useState<any>({});
  const [isSundayIncluded, setIsSundayIncluded] = useState<boolean>(false);
  const [isTodaySunday, setIsTodaySunday] = useState(false);
  const [slots, setSlots] = useState<any[]>([]);
  const [slotsOverrideData, setSlotsOverrideData] = useState<any[]>([]);
  const [mainMNVVanSlotAvailabilityID, setMainMNVVanSlotAvailabilityID] =
    useState<number>(0);

  const [slotModalOpen, setSlotModalOpen] = useState(false);

  useEffect(() => {
    checkIfTodayIsSunday();
    getVansById();
  }, []);

  function getVansById() {
    axiosAuth
      .get(AppContext.APIURL + "api/MNVQuote/GetSlotsAndVans")
      .then((response) => {
        if (response.data) {
          const deepCopy1 = JSON.parse(JSON.stringify(response.data.Data[0]));
          const deepCopy2 = JSON.parse(JSON.stringify(response.data.Data[0]));
          setVans(deepCopy1);
          setVansData(deepCopy2);
          getSlotsRelatedData(curentlySelectedDate, response.data.Data[0]);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching vans!", error);
      });
  }

  function getSlotsRelatedData(targetDate: string, thisvansData: any) {
    let data: any = { Date: targetDate };
    setCurentlySelectedDate(targetDate);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuote/GetEliminatedSlotsByDate", data)
      .then((response) => {
        if (response.data) {
          setSlots(response.data.Data[0]);
          setSlotsOverrideData(response.data.Data[1]);
          selectAllCheckbox();

          thisvansData=removePreviousDayData(thisvansData);
          for (var i = 0; i < response.data.Data[0].length; i++) {
            if (
              response.data.Data[0][i].SlotID > 0 &&
              document.getElementById(
                response.data.Data[0][i].MNVVanID +
                  "_" +
                  response.data.Data[0][i].SlotID
              ) != null
            ) {
              const element: any = document.getElementById(
                response.data.Data[0][i].MNVVanID +
                  "_" +
                  response.data.Data[0][i].SlotID
              ) as HTMLInputElement | null;
              element.checked = false;
            }
          }

          //console.log('param date: '+targetDate);
          //console.log('date: '+curentlySelectedDate);
          checkIfAnyMoverUnavailability(
            response.data.Data[0],
            response.data.Data[1],
            thisvansData,
            targetDate
          );
        }
      })
      .catch((error) => {
        console.error("Error getting slots data!", error);
      });
  }

  function checkIfAnyMoverUnavailability(
    slotsData: any[],
    overrideData: any[],
    vansData: any,
    p_oCurentlySelectedDate:any
  ) {
    const updatedVans = [...vansData];
    for (let i = 0; i < slotsData.length; i++) {
      const slot = slotsData[i];
      if (slot.SlotID === 0) {
        const l_oStartTime = new Date(slot.StartTime);
        const l_oEndTime = new Date(slot.EndTime);

        let l_arrVanSlots: any = FilterJsonExactlyMatching(
          vansData,
          "VanID",
          slot.MNVVanID
        );
        const l_intIndex = GetIndexExactlyMatchingColumn(
          vansData,
          "VanID",
          slot.MNVVanID
        );

        if (l_arrVanSlots.length > 0) {
          l_arrVanSlots = l_arrVanSlots[0].VanSlots;

          for (let j = 0; j < l_arrVanSlots.length; j++) {
            updatedVans[l_intIndex].VanSlots[j].MNVQuoteID = 0;
            updatedVans[l_intIndex].VanSlots[j].MNVVanSlotAvailabilityID = 0;
            updatedVans[l_intIndex].VanSlots[
              j
            ].MainMNVVanSlotAvailabilityID = 0;

            // Build datetime for slot start/end
            let l_strDate = `${new Date(p_oCurentlySelectedDate).getFullYear()}-${(
              "0" +
              (new Date(p_oCurentlySelectedDate).getMonth() + 1)
            ).slice(-2)}-${("0" + new Date(p_oCurentlySelectedDate).getDate()).slice(-2)}T${
              l_arrVanSlots[j].StartTime
            }:00`;
            const l_oSlotStartTime = new Date(l_strDate);

            l_strDate = `${new Date(p_oCurentlySelectedDate).getFullYear()}-${(
              "0" +
              (new Date(p_oCurentlySelectedDate).getMonth() + 1)
            ).slice(-2)}-${("0" + new Date(p_oCurentlySelectedDate).getDate()).slice(-2)}T${
              l_arrVanSlots[j].EndTime
            }:00`;
            const l_oSlotEndTime = new Date(l_strDate);

            if (
              IsDateTimeBetweenTwoDates(
                l_oStartTime,
                l_oSlotStartTime,
                l_oEndTime
              ) ||
              IsDateTimeBetweenTwoDates(
                l_oStartTime,
                l_oSlotEndTime,
                l_oEndTime
              )
            ) {
              setMainMNVVanSlotAvailabilityID(0);

              const MNVVanSlotAvailabilityID =
                checkIfAvailabilityOverrideExists(
                  slot.MNVQuoteID,
                  slot.MNVVanID,
                  l_arrVanSlots[j].SlotId,
                  overrideData
                );

              if (
                checkIfAvailabilityOverrideExists(
                  slot.MNVQuoteID,
                  slot.MNVVanID,
                  l_arrVanSlots[j].SlotId,
                  overrideData
                ) > 0
              ) {
                const element: any = document.getElementById(
                  slot.MNVVanID + "_" + l_arrVanSlots[j].SlotId
                ) as HTMLInputElement | null;
                element.checked = true;
              } else {
                const element: any = document.getElementById(
                  slot.MNVVanID + "_" + l_arrVanSlots[j].SlotId
                ) as HTMLInputElement | null;
                element.checked = false;
              }

              updatedVans[l_intIndex].VanSlots[j].MNVVanSlotAvailabilityID =
                MNVVanSlotAvailabilityID;
              updatedVans[l_intIndex].VanSlots[j].MainMNVVanSlotAvailabilityID =
                mainMNVVanSlotAvailabilityID;
              updatedVans[l_intIndex].VanSlots[j].MNVQuoteID = slot.MNVQuoteID;
              updatedVans[l_intIndex].VanSlots[j].ThisSlotStartTime =
                l_oSlotStartTime;

              // Calculate next slot start
              if (j < l_arrVanSlots.length - 1) {
                l_strDate = `${new Date(p_oCurentlySelectedDate).getFullYear()}-${(
                  "0" +
                  (new Date(p_oCurentlySelectedDate).getMonth() + 1)
                ).slice(-2)}-${("0" + new Date(p_oCurentlySelectedDate).getDate()).slice(-2)}T${
                  l_arrVanSlots[j + 1].StartTime
                }:00`;
              } else {
                l_strDate = `${new Date(p_oCurentlySelectedDate).getFullYear()}-${(
                  "0" +
                  (new Date(p_oCurentlySelectedDate).getMonth() + 1)
                ).slice(-2)}-${("0" + new Date(p_oCurentlySelectedDate).getDate()).slice(
                  -2
                )}T23:59:00`;
              }

              let l_oNextSlotStartTime = new Date(l_strDate);
              l_oNextSlotStartTime = addMinutes(l_oNextSlotStartTime, -1);

              updatedVans[l_intIndex].VanSlots[j].NextSlotStartTime =
                l_oNextSlotStartTime;
              updatedVans[l_intIndex].VanSlots[j].IsFromMoverUnavailability = 1;
            }
          }
        }
      }
    }

    setVans(updatedVans);
  }

  function removePreviousDayData(vansData: any) {
    let thisVan = [...vansData];

    for (var i = 0; i < thisVan.length; i++) {
      var l_arrVanSlots = thisVan[i].VanSlots;
      for (var j = 0; j < l_arrVanSlots.length; j++) {
        thisVan[i].VanSlots[j]["MNVQuoteID"] = 0;
        thisVan[i].VanSlots[j]["MNVVanSlotAvailabilityID"] = 0;
        thisVan[i].VanSlots[j]["MainMNVVanSlotAvailabilityID"] = 0;
      }
    }
    
    return thisVan;
  }

  function checkIfAvailabilityOverrideExists(
    MNVQuoteID: any,
    MNVVanID: any,
    MNVTimeSlotID: any,
    overrideData: any[]
  ) {
    for (let i = 0; i < overrideData.length; i++) {
      if (
        overrideData[i].MNVQuoteID === MNVQuoteID &&
        overrideData[i].MNVVanID === MNVVanID &&
        overrideData[i].MNVTimeSlotID === MNVTimeSlotID
      ) {
        setMainMNVVanSlotAvailabilityID(
          Number(overrideData[i].MainMNVVanSlotAvailabilityID)
        );
        return overrideData[i].MNVVanSlotAvailabilityID;
      }
    }
    return 0;
  }

  function selectAllCheckbox() {
    document
      .querySelectorAll<HTMLInputElement>(".chk")
      .forEach((chk) => (chk.checked = true));
  }

  function unselectAllCheckbox() {
    document
      .querySelectorAll<HTMLInputElement>(".chk")
      .forEach((chk) => (chk.checked = false));
  }

  function toggleSelect(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) selectAllCheckbox();
    else unselectAllCheckbox();
  }

  // Add Availability
  function addAvailabilityDataInMNVQuote() {
    let data: any = {
      Date: curentlySelectedDate,
      SlotID: currentlyClickedSlot.slotID,
      VanTypeID: currentlyClickedSlot.vanTypeID,
      VanID: currentlyClickedSlot.vanID,
      NextSlotStartTime: currentlyClickedSlot.NextSlotStartTime,
      SelectedAvailabilityTypeID: selectedAvailabilityTypeID,
      IsSundayIncluded: isSundayIncluded,
    };
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuote/AddAvailability", data)
      .then((response) => {
        setIsAnimation(false);
        setSlotModalOpen(false);

        getSlotsRelatedData(curentlySelectedDate, vansData);
      })
      .catch((error) => {
        console.error("Error adding availability!", error);
      });
  }

  // Delete Availability
  function deleteAvailabilityDataFromMNVQuote() {
    let data: any = {
      MNVQuoteID: currentlyClickedSlot.MNVQuoteID,
      Date: curentlySelectedDate,
      SlotID: currentlyClickedSlot.slotID,
      VanTypeID: currentlyClickedSlot.vanTypeID,
      VanID: currentlyClickedSlot.vanID,
      NextSlotStartTime: currentlyClickedSlot.NextSlotStartTime,
      SelectedAvailabilityTypeID: selectedAvailabilityTypeID,
      IsSundayIncluded: isSundayIncluded,
    };
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuote/DeleteAvailability", data)
      .then((response) => {
        setIsAnimation(false);
        setSlotModalOpen(false);

        getSlotsRelatedData(curentlySelectedDate, vansData);
      })
      .catch((error) => {
        console.error("Error deleting availability!", error);
      });
  }

  // inside your component
  const changeDate = (value: 1 | 2) => {
    let d = new Date(curentlySelectedDate); // `date` is your state string: "YYYY-MM-DD"

    if (value === 1) {
      d.setDate(d.getDate() - 1);
    } else if (value === 2) {
      d = new Date(curentlySelectedDate);
      d.setDate(d.getDate() + 1);
    }

    // Mirrors your original logic
    const next = d.toISOString().slice(0, 10);

    setCurentlySelectedDate(next);
    getSlotsRelatedData(next, vansData);
  };

  function OnDateChange(event: any) {
    setCurentlySelectedDate(event.target.value);
    getSlotsRelatedData(event.target.value, vansData);
  }

  const onChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    slotID: number,
    vanID: number,
    vanTypeID: number,
    index: number,
    vanSlots: any[],
    slot: any
  ) => {

    const updatedSlot = { ...slot };

    updatedSlot.vanTypeID = vanTypeID;
    updatedSlot.vanID = vanID;
    updatedSlot.slotID = slotID;

    if (!updatedSlot.MNVQuoteID || updatedSlot.MNVQuoteID === 0) {
      let nextSlotStartTime = "";

      if (index + 1 < vanSlots.length) {
        nextSlotStartTime = vanSlots[index + 1]?.StartTime;
      }

      updatedSlot.NextSlotStartTime = nextSlotStartTime;

      if (!event.target.checked) {
        updatedSlot.IsAddClicked = true;
      } else {
        updatedSlot.IsAddClicked = false;

        for (let i = 0; i < slots.length; i++) {
          if (slots[i].SlotID === slotID && slots[i].MNVVanID === vanID) {
            updatedSlot.MNVQuoteID = slots[i].MainQuoteID;
            break;
          }
        }
      }

      updatedSlot.IsReverseClicked = true;
    } else {
      updatedSlot.IsAddClicked = event.target.checked;
      updatedSlot.IsReverseClicked = false;
    }

    setCurrentlyClickedSlot({ ...updatedSlot });
    setSelectedAvailabilityTypeID(1);
    setSlotModalOpen(true);
  };

  const addMNVVanSlotAvailabilityRecords = async () => {
    const data = {
      MNVVanSlotAvailabilityID: 0,
      MNVQuoteID: currentlyClickedSlot.MNVQuoteID,
      MNVVanID: currentlyClickedSlot.vanID,
      MNVTimeSlotID: currentlyClickedSlot.slotID,
      SelectedAvailabilityTypeID:selectedAvailabilityTypeID,
      IsSundayIncluded:isSundayIncluded,
      ApplyOverride: 1,
      StartTime: currentlyClickedSlot.ThisSlotStartTime,
      EndTime: currentlyClickedSlot.NextSlotStartTime,
      ExtraTextField1: "",
      CreatedByID: 0,
      CreationTimestamp: new Date(),
      LastUpdatedByID: 0,
      LastUpdatedTimestamp: new Date(),
      IsDeleted: false,
    };

    try {
      setIsAnimation(true);

      await axiosAuth.post(
        AppContext.APIURL +
          "api/MNVVanSlotAvailability/MNVVanSlotAvailabilitySaveCustom",
        data
      );

      setSlotModalOpen(false);
      getSlotsRelatedData(curentlySelectedDate, vansData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsAnimation(false);
    }
  };

  const deleteMNVVanSlotAvailabilityRecords = async () => {
    const data = {
      MNVVanSlotAvailabilityID: currentlyClickedSlot.MNVVanSlotAvailabilityID,
      MainMNVVanSlotAvailabilityID:
        currentlyClickedSlot.MainMNVVanSlotAvailabilityID,
      MNVQuoteID: currentlyClickedSlot.MNVQuoteID,
      MNVVanID: currentlyClickedSlot.vanID,
      MNVTimeSlotID: currentlyClickedSlot.slotID,
      SelectedAvailabilityTypeID:selectedAvailabilityTypeID,
      IsSundayIncluded:isSundayIncluded,
      ApplyOverride: 1,
      StartTime: currentlyClickedSlot.ThisSlotStartTime,
      EndTime: currentlyClickedSlot.NextSlotStartTime,
      ExtraTextField1: "",
      CreatedByID: 0,
      CreationTimestamp: new Date(),
      LastUpdatedByID: 0,
      LastUpdatedTimestamp: new Date(),
      IsDeleted: false,
    };

    try {
      setIsAnimation(true);

      await axiosAuth.post(
        AppContext.APIURL +
          "api/MNVVanSlotAvailability/MNVVanSlotAvailabilityDeleteRecordCustom",
        data
      );

      setSlotModalOpen(false);
      getSlotsRelatedData(curentlySelectedDate, vansData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsAnimation(false);
    }
  };

  const checkIfTodayIsSunday = () => {
    const isSunday = new Date().getDay() === 0;

    setIsTodaySunday(isSunday);
    setIsSundayIncluded(isSunday);
  };

  return (
    <>
      <div className="inline-block-d width-100 p-all10">
        {isAnimation && <LoadingAnimation />}
        <div className="inline-block-d text-center width-100 reuse-border p-all20 font-mont">
          <div className="flex-d flex-ac flex-jsb">
            <div className="flex-da flex-gap10">
              <a className="flex-d" onClick={() => changeDate(1)}>
                <img
                  src="/images/previous.svg"
                  width="15"
                  height="20"
                  alt="previous"
                />
              </a>
              <input
                className="input-field w-100 field-input" 
                type="date"
                value={curentlySelectedDate}
                onChange={(e) => OnDateChange(e)}
                onClick={(e: any) => e.target.showPicker()}
              />
              <a className="flex-d" onClick={() => changeDate(2)}>
                <img
                  src="/images/next.svg"
                  width="15"
                  height="20"
                  alt="previous"
                />
              </a>
            </div>
          </div>
          <div className="grid-d">
            {vans &&
              vans.map((van: any, index: any) => (
                <React.Fragment key={van.VanID}>
                  <div className="flex-d flex-ac flex-gap20 mt-30">
                    <span className="bold-font font-18 flex-d text-cap">
                      {van.VanName}
                    </span>
                    <span className="data-boxes data-boxes2">
                      <span>{van.VanRegistrationNumber}</span>
                    </span>
                  </div>
                  <div className="grid-d fr-1111 r-gap20 mt-20">
                    {van.VanSlots.map((slots: any, slotsindex: any) => (
                      <div
                        key={slots.SlotId}
                        className="flex-d flex-ac flex-gap20"
                      >
                        <input
                          className="chk"
                          type="checkbox"
                          id={`${van.VanID}_${slots.SlotId}`}
                          onChange={(e) =>
                            onChange(
                              e,
                              slots.SlotId,
                              van.VanID,
                              van.VanTypeID,
                              slotsindex,
                              van.VanSlots,
                              slots
                            )
                          }
                        />
                        <span>{slots.Name}</span>
                      </div>
                    ))}
                  </div>
                </React.Fragment>
              ))}
          </div>

          {/* Unavailability */}
          <div className="grid-d mt-30">
            <span className="bold-font font-18 flex-d text-cap">
              Unavailability
            </span>

            <div className="flow-auto mt-10">
              <table className="reuse-table">
                <thead>
                  <tr>
                    <th>Van</th>
                    <th>Slot</th>
                    <th>Rule Type</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                  </tr>
                </thead>
                <tbody>
                  {slots &&
                    slots.map((Row, idx) => (
                      <tr key={idx}>
                        <td>{Row.VanName}</td>
                        <td>{Row.SlotName}</td>
                        <td>
                          {Row.TotalEntries === 1
                            ? "Once"
                            : Row.TotalEntries >= 100
                            ? "Every Day"
                            : Row.TotalEntries >= 36
                            ? "Once Every Week"
                            : Row.TotalEntries >= 19
                            ? "Once Every 2 Weeks"
                            : Row.TotalEntries >= 14
                            ? "Once Every 3 Weeks"
                            : Row.TotalEntries >= 13
                            ? "Once Every 4 Weeks"
                            : Row.TotalEntries > 1
                            ? "Once Every Month"
                            : ""}
                        </td>
                        <td>{formateDate(Row.StartTime)}</td>
                        <td>{formateDate(Row.EndTime)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Availability */}
          <div className="grid-d mt-30">
            <span className="bold-font font-18 flex-d text-cap">
              Availability
            </span>

            <div className="flow-auto mt-10">
              <table className="reuse-table">
                <thead>
                  <tr>
                    <th>Van</th>
                    <th>Slot</th>
                    <th>Rule Type</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                  </tr>
                </thead>
                <tbody>
                  {slotsOverrideData &&
                    slotsOverrideData.map((Row, idx) => (
                      <tr key={idx}>
                        <td>{Row.VanName}</td>
                        <td>{Row.SlotName}</td>
                        <td>
                          {Row.TotalEntries === 1
                            ? "Once"
                            : Row.TotalEntries >= 100
                            ? "Every Day"
                            : Row.TotalEntries >= 36
                            ? "Once Every Week"
                            : Row.TotalEntries >= 19
                            ? "Once Every 2 Weeks"
                            : Row.TotalEntries >= 14
                            ? "Once Every 3 Weeks"
                            : Row.TotalEntries >= 13
                            ? "Once Every 4 Weeks"
                            : Row.TotalEntries > 1
                            ? "Once Every Month"
                            : ""}
                        </td>
                        <td>{formateDate(Row.StartTime)}</td>
                        <td>{formateDate(Row.EndTime)}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {slotModalOpen && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0"> Slots Availability</h3>
                <a
                  className="close-help"
                  onClick={() => setSlotModalOpen(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d gap-20 mt-20">
                {/* ADD CLICKED */}
                {currentlyClickedSlot?.IsAddClicked && (
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Mark as {currentlyClickedSlot.IsReverseClicked && "un"}
                      available for:
                    </span>

                    <select
                      className="input-field w-100"
                      value={selectedAvailabilityTypeID}
                      onChange={(e) =>
                        setSelectedAvailabilityTypeID(Number(e.target.value))
                      }
                    >
                      {VanAvailabilityTypes.map((option: any) => (
                        <option key={option.ID} value={option.ID}>
                          {option.Name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* NOT ADD CLICKED */}
                {!currentlyClickedSlot?.IsAddClicked && (
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      Mark as {!currentlyClickedSlot.IsReverseClicked && "un"}
                      available for:
                    </span>

                    <select
                      className="input-field w-100"
                      value={selectedAvailabilityTypeID}
                      onChange={(e) =>
                        setSelectedAvailabilityTypeID(Number(e.target.value))
                      }
                    >
                      <option value={1}>Once</option>
                      <option value={2}>Delete Entire Rule</option>
                    </select>
                  </div>
                )}

                {/* INCLUDE SUNDAYS */}
                {currentlyClickedSlot?.IsAddClicked &&
                  (selectedAvailabilityTypeID === 2 ||
                    selectedAvailabilityTypeID === 7) &&
                  !isTodaySunday && (
                    <div className="flex-d flex-ac flex-gap10 font-mont">
                      <input
                        type="checkbox"
                        checked={isSundayIncluded}
                        onChange={(e) => setIsSundayIncluded(e.target.checked)}
                      />
                      <span className="font-12 text-left label-color">
                        Include Sundays?
                      </span>
                    </div>
                  )}

                {/* SAVE BUTTONS */}
              </div>

              <div className="flex-daj btn-start flex-gap10 mt-20">
                {!currentlyClickedSlot?.IsReverseClicked && (
                  <>
                    {currentlyClickedSlot?.IsAddClicked ? (
                      <a
                        className="btn-primary flex-daj"
                        onClick={addMNVVanSlotAvailabilityRecords}
                      >
                        Save
                      </a>
                    ) : (
                      <a
                        className="btn-primary flex-daj"
                        onClick={deleteMNVVanSlotAvailabilityRecords}
                      >
                        Save
                      </a>
                    )}
                  </>
                )}

                {currentlyClickedSlot?.IsReverseClicked && (
                  <>
                    {currentlyClickedSlot?.IsAddClicked ? (
                      <a
                        className="btn-primary flex-daj"
                        onClick={addAvailabilityDataInMNVQuote}
                      >
                        Save
                      </a>
                    ) : (
                      <a
                        className="btn-primary flex-daj"
                        onClick={deleteAvailabilityDataFromMNVQuote}
                      >
                        Save
                      </a>
                    )}
                  </>
                )}
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    setSlotModalOpen(false);
                  }}
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VanAvailability;
